import store from '~/Store';
import AbstractPreloader from '~/core/AppInit/AbstractPreloader';
import { loadFeatures } from '~/Actions/ActionFeatures';
import { settings } from '~/utils/settings';

export default class FeaturesPreloader extends AbstractPreloader {
    async load(): Promise<any> {
        if (!settings.disableShipFeatures) {
            // @ts-ignore
            store.dispatch(loadFeatures());
        }
        return Promise.resolve(1);
    }
}
